module.exports = __webpack_public_path__ + "img/bg.45dcbe1d.png";